/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-danger */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { formatChangeValue, formatFieldLabel } from '../../Utils/Constants/utils';
import { getCorporateNameById } from '../../redux/corporateSlice';

const USER_FLEETS_FIELD_REGEX = /allUserFleetEntities/i;
const ASSIGNED_DRIVER_VEHICLE_FIELD_REGEX = /assignedDriverVehicle/i;
const DRIVER_VEHICLE_TYPE_FIELD_REGEX = /^driverVehicleType$/i;

const isCorporateField = (field) => field === 'corporateId';
const isUserFleetsField = (field) => USER_FLEETS_FIELD_REGEX.test(field);
const isAssignedDriverVehicleField = (field) => ASSIGNED_DRIVER_VEHICLE_FIELD_REGEX.test(field);
const isDriverVehicleTypeField = (field) => DRIVER_VEHICLE_TYPE_FIELD_REGEX.test(field);

const isObjectValue = (value) =>
	value !== null && typeof value === 'object' && !Array.isArray(value);

const AuditDetailValue = ({ field, value, index, entries }) => {
	const [corporateName, setCorporateName] = useState('');
	const [corporateLoading, setCorporateLoading] = useState(false);
	const dispatch = useDispatch();

	const isCorporate = isCorporateField(field);
	const isUserFleets = isUserFleetsField(field);
	const isAssignedDriverVehicle = isAssignedDriverVehicleField(field);
	const isDriverVehicleType = isDriverVehicleTypeField(field);

	useEffect(() => {
		if (!isCorporate || !Number.isFinite(value)) {
			return;
		}

		const fetchCorporate = async () => {
			try {
				setCorporateLoading(true);

				const corporate = await dispatch(getCorporateNameById(value)).unwrap();

				setCorporateName(corporate);
			} finally {
				setCorporateLoading(false);
			}
		};

		fetchCorporate();
	}, [dispatch, isCorporate, value]);

	let displayValue;

	if (isCorporate) {
		displayValue = corporateLoading ? 'Loading...' : corporateName;
	} else if (isUserFleets) {
		const uniqueOperators = [...new Set(value.map((item) => item.name))];

		displayValue = uniqueOperators.length ? (
			<div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 6,
				}}>
				{uniqueOperators.map((name) => (
					<span
						key={name}
						style={{
							padding: '5px 10px',
							borderRadius: 6,
							background: '#f5f5f5',
							border: '1px solid #e8e8e8',
							color: '#262626',
							fontSize: 13,
							fontWeight: 500,
						}}>
						{name}
					</span>
				))}
			</div>
		) : (
			<span style={{ color: '#999' }}>No fleet operators</span>
		);
	} else if (isAssignedDriverVehicle) {
		const uniqueDrivers = [...new Map(value.map((driver) => [driver.email, driver])).values()];

		displayValue = uniqueDrivers.length ? (
			<div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 6,
				}}>
				{uniqueDrivers.map((driver) => (
					<span
						key={driver.email}
						style={{
							padding: '5px 10px',
							borderRadius: 6,
							background: '#f5f5f5',
							border: '1px solid #e8e8e8',
							color: '#262626',
							fontSize: 13,
							fontWeight: 500,
						}}>
						{`${driver.name?.trim() || ''} ${driver.surname || ''}`.trim()}
					</span>
				))}
			</div>
		) : (
			<span style={{ color: '#999' }}>No assigned drivers</span>
		);
	} else if (isDriverVehicleType) {
		const uniqueVehicleTypes = [
			...new Set(
				value.map((vehicleType) => vehicleType?.vehicleType?.trim()).filter(Boolean),
			),
		];

		displayValue = uniqueVehicleTypes.length ? (
			<div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 6,
				}}>
				{uniqueVehicleTypes.map((vehicleType) => (
					<span
						key={vehicleType}
						style={{
							padding: '5px 10px',
							borderRadius: 6,
							background: '#f5f5f5',
							border: '1px solid #e8e8e8',
							color: '#262626',
							fontSize: 13,
							fontWeight: 500,
						}}>
						{vehicleType}
					</span>
				))}
			</div>
		) : (
			<span style={{ color: '#999' }}>No vehicle types</span>
		);
	} else if (isObjectValue(value)) {
		const objectEntries = Object.entries(value).filter(
			([, item]) => item !== null && item !== undefined && item !== '',
		);

		if (objectEntries.length === 1) {
			displayValue = formatChangeValue(objectEntries[0][1]);
		} else {
			displayValue = (
				<div
					style={{
						background: '#fafafa',
						border: '1px solid #e8e8e8',
						borderRadius: 8,
						padding: '10px 12px',
					}}>
					{objectEntries.map(([key, item], itemIndex) => (
						<div
							key={key}
							style={{
								display: 'flex',
								gap: 10,
								padding: '5px 0',
								borderBottom:
									itemIndex === objectEntries.length - 1
										? 'none'
										: '1px solid #f0f0f0',
							}}>
							<span
								style={{
									color: '#888',
									fontSize: 13,
									minWidth: 90,
								}}>
								{formatFieldLabel(key)}
							</span>

							<span
								style={{
									color: '#262626',
									fontSize: 13,
									fontWeight: 500,
									overflowWrap: 'anywhere',
								}}>
								{String(item)}
							</span>
						</div>
					))}
				</div>
			);
		}
	} else {
		displayValue = formatChangeValue(value);
	}

	return (
		<div
			key={field}
			style={{
				display: 'grid',
				gridTemplateColumns: '180px 1fr',
				gap: 12,
				alignItems: 'center',
				padding: '12px 14px',
				borderBottom: index === (entries?.length ?? 0) - 1 ? 'none' : '1px solid #f0f0f0',
			}}>
			<div
				style={{
					fontWeight: 600,
					color: '#262626',
					overflowWrap: 'anywhere',
				}}>
				{formatFieldLabel(field)}
			</div>

			<div
				style={{
					overflowWrap: 'anywhere',
					wordBreak: 'break-word',
					minWidth: 0,
				}}>
				{displayValue}
			</div>
		</div>
	);
};

export default AuditDetailValue;
